import React from 'react';
import { useI18n } from '../i18n';
import { faqs, company } from '../mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { ShieldCheck, Award, Globe2 } from 'lucide-react';

const About = () => {
  const { t, lang } = useI18n();
  return (
    <div className="pt-[72px] bg-white">
      <section className="relative bg-black text-white py-24">
        <div className="absolute inset-0 bg-cover bg-center opacity-50" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1603087462214-2aadc739429c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBjaGF1ZmZldXJ8ZW58MHx8fHwxNzc4MDY2NzA0fDA&ixlib=rb-4.1.0&q=85')" }} />
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="text-[11px] tracking-[0.4em] uppercase text-white/60">About</p>
          <h1 className="font-serif text-5xl md:text-6xl mt-4 max-w-3xl leading-[1.05]">{t('about.title')}</h1>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-12 items-start">
          <div className="space-y-5 text-black/70 leading-relaxed text-lg">
            <p>{t('about.p1')}</p>
            <p>{t('about.p2')}</p>
          </div>
          <div className="grid grid-cols-1 gap-6">
            {[
              { icon: ShieldCheck, t: lang === 'fr' ? 'Licence VTC officielle' : 'Official chauffeur licence' },
              { icon: Award, t: lang === 'fr' ? 'Service 5 étoiles' : '5-star service' },
              { icon: Globe2, t: lang === 'fr' ? 'France & Europe' : 'France & Europe' }
            ].map((f, i) => (
              <div key={i} className="flex items-start gap-4 border border-black/10 p-5">
                <div className="w-10 h-10 bg-black text-white flex items-center justify-center"><f.icon className="w-5 h-5" /></div>
                <p className="font-serif text-xl mt-1">{f.t}</p>
              </div>
            ))}
            <div className="border border-black/10 p-5 text-sm text-black/70 leading-relaxed">
              <p className="font-serif text-xl text-black">{company.name}</p>
              <p className="mt-2">{company.address}</p>
              <p className="mt-1">{company.phone}</p>
              <p className="mt-1">{company.email}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#f6f4f1]">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10">
          <h2 className="font-serif text-4xl md:text-5xl">{t('faq.title')}</h2>
          <Accordion type="single" collapsible className="mt-10">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`q${i}`} className="border-b border-black/10">
                <AccordionTrigger className="text-left text-lg font-serif py-5">{lang === 'fr' ? f.qFr : f.qEn}</AccordionTrigger>
                <AccordionContent className="text-black/70 leading-relaxed">{lang === 'fr' ? f.aFr : f.aEn}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
};

export default About;
